import type {RouteRecordRaw} from 'vue-router';
//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
//================= [VUE COMPONENTS] ==========================

export const statisticRoutes: RouteRecordRaw[] = [
  {
    path: i18n.global.t('routes.statistic.statistic'),
    name: Routes.STATISTIC,
    component: () => import('@/components/statistic/StatisticDashboard.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statistic'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticDevice'),
    name: Routes.STATISTIC_DEVICE,
    component: () => import('@/components/statistic/types/StatisticDevice.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticDevice'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticUser'),
    name: Routes.STATISTIC_USER,
    component: () => import('@/components/statistic/types/StatisticUser.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticUser'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticUserOnlineTime'),
    name: Routes.STATISTIC_USER_ONLINE_TIME,
    component: () => import('@/components/statistic/types/StatisticUserOnlineTime.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticUserOnlineTime'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticOverview'),
    name: Routes.STATISTIC_OVERVIEW,
    component: () => import('@/components/statistic/StatisticOverview.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticOverview'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticClients'),
    name: Routes.STATISTIC_CLIENTS,
    component: () => import('@/components/statistic/StatisticClients.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticClients'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticClientDetail'),
    name: Routes.STATISTIC_CLIENT_DETAIL,
    component: () => import('@/components/statistic/StatisticClientDetail.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticClientDetail'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticAtRisk'),
    name: Routes.STATISTIC_AT_RISK,
    component: () => import('@/components/statistic/StatisticAtRisk.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticAtRisk'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticFunnel'),
    name: Routes.STATISTIC_FUNNEL,
    component: () => import('@/components/statistic/StatisticFunnel.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticFunnel'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticFunnelDetail'),
    name: Routes.STATISTIC_FUNNEL_DETAIL,
    component: () => import('@/components/statistic/StatisticFunnelDetail.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticFunnelDetail'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticRetention'),
    name: Routes.STATISTIC_RETENTION,
    component: () => import('@/components/statistic/StatisticRetention.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticRetention'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticActivation'),
    name: Routes.STATISTIC_ACTIVATION,
    component: () => import('@/components/statistic/StatisticActivation.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticActivation'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticDiaryResponse'),
    name: Routes.STATISTIC_DIARY_RESPONSE,
    component: () => import('@/components/statistic/StatisticDiaryResponse.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticDiaryResponse'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticBandTrend'),
    name: Routes.STATISTIC_BAND_TREND,
    component: () => import('@/components/statistic/StatisticBandTrend.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticBandTrend'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.statistic.statisticLifecycle'),
    name: Routes.STATISTIC_LIFECYCLE,
    component: () => import('@/components/statistic/StatisticLifecycle.vue'),
    meta: {
      title: i18n.global.t('titles.statistic.statisticLifecycle'),
      active: 'statistic',
      coaching: 'statistic',
      userType: 'admin',
    },
  },
];
